export default __webpack_public_path__ + "static/media/popularService(1).c9905c9a.png";